let React               = require("react");
const {  Link  } = require('react-router-dom');
let ExportModel3DButton = require("../buttons/ExportModel3DButton.jsx");
let DeleteButton        = require("../buttons/DeleteButton.jsx");
let ViewButton          = require("../buttons/ViewButton.jsx");
let AssetCard           = require("./generic/AssetCard.jsx");
let AssetDetailsLink    = require("../../controls/buttons/AssetDetailsLink.jsx");
let CircuitsUtil        = require("./../../util/CircuitsUtil.js");
let ObservableUtil =      require("../../util/ObservableUtil.js");

class Model3DCard extends React.Component {

    constructor(){
        super();
        this.state = {objUrl: {}, isLink: false};
        
        this.uploadFinished = this.uploadFinished.bind(this);
    }

    componentWillMount(){
        let {id, name } = this.props.resource;
        let pathname = CircuitsUtil.getViewUrl("3dmodels", id, name);
        this.setState({objUrl: {pathname, state: { modal: true, previousView: location.pathname }}});
        
        if(this.props.isPublicFacing || CircuitsUtil.modelTranslationSuccess(this.props.resource)){
          this.setState({isLink: true});
        }
    }
    
    uploadFinished(){
        this.setState({isLink: true});
    }

    render() {
        const { resource, isPublicFacing = false } = this.props;
        
        if(CircuitsUtil.modelTranslationSuccess(this.props.resource) && !this.state.isLink){
          this.uploadFinished();
        }

        let {   
                hubDeleted = false,
                Buttons = {
                    grid:{
                            default:[
                                DeleteButton,
                                ExportModel3DButton,
                            ],
                            failed:[
                                DeleteButton 
                            ],
                            warning:[
                                DeleteButton,
                                ExportModel3DButton,
                                
                            ]
                    },
                    list:{
                            default:[
                                ExportModel3DButton,
                                DeleteButton
                            ],
                            failed:[
                                DeleteButton 
                            ],
                            warning:[
                                ExportModel3DButton,
                                DeleteButton
                            ]
                    }
                }, 
                Action = this.state.isLink ? props => <AssetDetailsLink {...props} objUrl={this.state.objUrl}/>:
                                    props => <props.Content noLink={true}/>
        } = this.props;

        return <AssetCard
                    {...this.props}
                    uploadFinished={this.uploadFinished}
                    Action={Action}
                    urlName="3dmodels"
                    cssCardTag="package"
                    Buttons={hubDeleted? null: Buttons}
                />
    }
}

module.exports = Model3DCard;
